import api, { apiAction, apiActionWithRoute } from '../../api'

import capitalize from '../../common/formatters/capitalize'

export const fetchItems = entityName => () =>
  apiAction(api[`get${capitalize(entityName)}s`])()

export const addItem = entityName => name =>
  apiAction(api[`add${capitalize(entityName)}`])({ name })

export const deleteItem = entityName => entityId =>
  apiActionWithRoute(api[`delete${capitalize(entityName)}`])(entityId)()

export const updateItem = entityName => (entityId, name) =>
  apiActionWithRoute(api[`update${capitalize(entityName)}`])(entityId)({ name })
